module.exports = __webpack_public_path__ + "static/media/user.23d13a1d.png";